export function getAttrValue(attr: string): string | undefined {
  const elWithAttr = document.querySelector(`[${attr}]`)
  if (elWithAttr == null) {
    return undefined
  }
  const attrValue = elWithAttr.getAttribute(attr)
  if (attrValue == null) {
    return undefined
  }
  return attrValue
}

export function getElementWithAttr(attr: string): HTMLElement | null {
  return document.querySelector(`[${attr}]`)
}

export function getAllElementsWithAttr(attr: string): NodeListOf<HTMLElement> {
  return document.querySelectorAll(`[${attr}]`)
}

export function setStyleAttribute(element: HTMLElement, attrs: { [key: string]: string }): void {
  Object.keys(attrs).forEach((k: string) => {
    element.style.setProperty(k, attrs[k])
  })
}

export function setElementAttribute(element: HTMLElement, attrs: { [key: string]: string }): void {
  Object.keys(attrs).forEach((k: string) => {
    element.setAttribute(k, attrs[k])
  })
}

export function initURL(endpoint: string): string {
  const url = new URL(endpoint)
  url.pathname += 'api/v1/init'
  return url.href
}

export function iframeURL(endpoint: string, challengeType: string): string {
  const url = new URL(endpoint)
  url.pathname += `static/${challengeType}/`
  return url.href
}
